<template>
  <div>
    <div class="cas-ban">
      <img src="static/img/home_ban.png" />
    </div>
    <div class="cas-code">
      <img src="static/img/fail.png" v-if="isError" />
      <p>{{ response }}</p>
    </div>
  </div>
</template>
<script>
import { aApi } from "../utils/auth";
import { Api } from '../utils/axios';
export default {
  data() {
    return {
      response: "加载中...",
      isError: false,
      data: [
        { menu: "xs_cj", path: "student/score" },
        { menu: "xs_xjgl", path: "student/schoolRoll" },
        { menu: "xs_ksap", path: "student/exam" },//学生-考试安排
        { menu: "xs_hk", path: "student/delayedExam" },//学生-缓考
        { menu: "xs_djksbm", path: "student/gradeExam" },//学生-等级考试报名
        { menu: "xs_pyfa", path: "student/cultivate" },//学生-培养方案
        { menu: "xs_xspj", path: "student/evaluate" },//学生-学生评教
        { menu: "xs_xk", path: "student/pickClass" },//学生-选课
        { menu: "xs_kcb", path: "new/Table" },//学生-课程表
        { menu: "xs_jc", path: "student/textbook" },//学生-教材
        { menu: "xs_kq", path: "student/attendanceAdd" },//学生—课堂签到
        { menu: "xs_bk", path: "student/supplementExam" },
        { menu: "xs_xqkscj", path: "/student/semester_Score" },//学生-学期考试成绩
        { menu: "xs_pyfamx", path: "train/index" },//学生-培养方案明细
        { menu: "xs_xjyj", path: "student/curWarn" },
        { menu: "xs_jxjd", path: "student/syllabus" },//学生-教学进度
        { menu: "xs_cjrd", path: "/student/score_Affirmation" },//学生-成绩认定
        { menu: "xs_kxjs", path: "restRooms/index" },//学生-空闲教室
        { menu: "xs_zxjh", path: "student/executePlan" },//执行计划
        { menu: "xs_djkscj", path: "student/grades_score" },//学生-等级考试成绩
        { menu: "xs_xjyd", path: "student/change" },//学生-学籍异动
        { menu: "xs_xjyj", path: "student/warning" },//学生-学籍预警
        { menu: "js_kcb", path: "surfaces" },//课程表
        { menu: "js_tksq", path: "exchangeK/index" },//调课申请
        { menu: "js_jkcx", path: "invigilate" },//监考查询
        { menu: "js_jsjy", path: "classroom" },
        { menu: "js_jsjy_new", path: "bindex" },//教室借用
        { menu: "js_jxpj", path: "evaluate" },//教学评价
        { menu: "js_cjgl", path: "achievement1" },
        { menu: "js_pyfa", path: "programme" },//培养方案
        { menu: "js_bysj", path: "design" },
        { menu: "js_kt", path: "teacher/courseManage" },
        { menu: "js_kq", path: "teacher/attendance" },//课堂签到
        { menu: "js_kw", path: "teacher/examinationIndex" },
        { menu: "js_sh", path: "pass/index" },
        { menu: "js_cjxg", path: "grade/update/index" },//成绩修改
        { menu: "js_jsjysh", path: "teacher/examine/borrowingList" },//教室借用审核
        { menu: "js_pyfash", path: "teacher/guideIndex" },//培养方案审核
        { menu: "js_kksqsh", path: "teacher/courseAudit" },//开课申请审核
        { menu: "js_tksh", path: "teacher/examine/adjustList" },//调课审核
        { menu: "js_hksh", path: "teacher/bookIndex?id=6" },//学生缓考审核
        { menu: "js_cjlrsh", path: "pass/passIndex" },//成绩录入审核
        { menu: "js_pyfa_jxjh", path: "train/teachingPlan" },//教学计划
        { menu: "js_pyfa_zy", path: "train/commonIndex" },//专业培养方案
        { menu: "js_pyfazg", path: "/train/indpyfazgIndexex" },//培养方案总纲
        { menu: "js_zyjxjc", path: "/train/teachingProcess" },//专业教学进程
        { menu: "js_jc", path: "/teacher/textbook" },//教材
        { menu: "js_dgsx", path: "/internshipTeacher/index" },//顶岗实习
        { menu: "xs_dgsx", path: "/internship/index" },//顶岗实习
        {menu:"js_gzlcx",path:"/workNum/index"},//教师-工作量查询
        {menu:"js_tksh_detail","path":"teacher/examine/adjustListDetailCas?casLogin=1"},//教师-调课审核详情
        {menu:"js_kctdsh_detail",path:"/applyDetail?casLogin=1&ywcode=011"},//教师-课程替代审核详情
        {menu:"js_hksh_detail",path:"/applyDetail?casLogin=1&ywcode=019"},//教师-缓考审核详情
        {menu:"js_pyfash_detail",path:"/teacher/guideMain?casLogin=1"},//教师-培养方案审核详情
        {menu:"js_cjlrsh_detail",path:"/teacher/examine/scoreListDetail?casLogin=1"},//教师-成绩录入审核详情

        { menu: "js_sh_xzkc", path: "/teacher/courseAudit?type=0" },//新增课程审核
        { menu: "js_sh_jhwt","path":"/teacher/verifyIndex"},// 计划微调审核
        { menu: "js_sh_cjrd","path":"/teacher/bookIndex?id=9"},// 成绩认定审核
        { menu: "js_sh_bysxx","path":"/teacher/bookIndex?id=3"},// 毕业生信息审核
        { menu: "js_sh_smsq","path":"/teacher/bookIndex?id=0"},// 书目申请审核
        { menu: "js_sh_xsyssh","path":"/teacher/bookIndex?id=1"},// 学生用书征订审核
        { menu: "js_sh_cjxg","path":"/teacher/bookIndex?id=10"},// 成绩修改审核

        // 通知公告
        { menu: "ysgg", path: "/adv" },
        { menu: "dclxx", path: "/notice?type=0" },
        { menu: "ydxx", path: "/notice?type=2" },
        { menu: "xxtz", path: "/new/Msg" },
        { menu: "ysggxq", path: "/advItem" },
        //家长
        { menu: "jz_cjcx", path: "/student/jzcjcx" }
      ]
    };
  },
  created() {
    if(!sessionStorage.getItem('schoolCode')||sessionStorage.getItem('schoolCode')==""||sessionStorage.getItem('schoolCode')==null){
       this.ss();
    }else{
      if(sessionStorage.getItem('schoolCode')=="12845"){
           document.title= "移动端";
      }else if(sessionStorage.getItem('schoolCode')=="14073"){
           document.title= "教务服务";
      }
    }

    sessionStorage.removeItem("isNeedLogout");
    sessionStorage.setItem("ifSelect", 0);
    sessionStorage.setItem("menuSave", "0");
    if (this.$route.query.weChart && this.$route.query.weChart == 1) {
      sessionStorage.setItem("isWechat", 1);
    } else {
      sessionStorage.removeItem("isWechat");
    }
    if (this.$route.query.thirdLogin) {
      sessionStorage.setItem("thirdLogin", this.$route.query.thirdLogin);
    } else {
      sessionStorage.removeItem("thirdLogin");
    }
    //单点登录判断
    sessionStorage.setItem("casLogin", true);
    sessionStorage.setItem("Identity", this.$route.query.userType);
    if(this.$route.query.userType){
      sessionStorage.setItem("userType",this.$route.query.userType);
    }
    this.ifWechatBrowser();
    if (this.$route.query.token || this.$route.query.askToken) {
      sessionStorage.setItem(
        "Token",
        this.$route.query.token || this.$route.query.askToken
      );
      if (
        this.$route.query.toMenu &&
        this.$route.query.toMenu != null &&
        this.$route.query.toMenu != "" &&
        this.$route.query.toMenu != "null"
      ) {
        // 菜单跳转
        this.menuCheck(this.$route.query.toMenu);
      } else {
         if(sessionStorage.getItem('schoolCode')=="10013"){
            this.getInfo();
            this.$router.replace("/new/Home_10013");
         }else{
            this.getInfo();
            this.$router.replace("/index");
         }
        
      }
    } else {
      this.codeDiffer();
    }
  },
  methods: {
    async getInfo() {
      const res = await aApi.initUserInfo();
      sessionStorage.setItem("userInfo", JSON.stringify(res));
    },
    getPwdKey(){
      let monthVal = new Date().getMonth();
      if(monthVal>=9){
        monthVal = monthVal+1;
      }else{
        monthVal = "0"+(monthVal+1);
      }
      let dateVal = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate();
      let keyArr = [];
      keyArr.push(new Date().getFullYear());
      keyArr.push(monthVal);
      keyArr.push(dateVal);
      let strpwd = "";
      let pwdPosion = "";
      for(let i=0;i<3;i++){
        let rndNb = Math.ceil(Math.random()*9);
        pwdPosion+=rndNb;
        for(let k=0;k<rndNb*1;k++){
          strpwd+=Math.ceil(Math.random()*9);
        }
        strpwd+=keyArr[i];
      }
      strpwd+=pwdPosion;
      return strpwd;
    },
    async ss() {
        let keystr = this.getPwdKey();
        const params = {
           'parmKeid':keystr
        }
        const res = await Api.getSchoolCode(params)
        sessionStorage.setItem('schoolCode',res.data.schoolcode);
        if(sessionStorage.getItem('schoolCode')=="12845"){
           document.title= "移动端";
        }else if(sessionStorage.getItem('schoolCode')=="14073"){
           document.title= "教务服务";
        }
    },
    codeDiffer() {
      this.isError = true;
      if (this.$route.query.code == 1) {
        this.response = "无法获取用户信息！";
      } else if (this.$route.query.code == 2) {
        this.response = "用户不存在！";
      } else if (this.$route.query.code == 3) {
        this.response = "登录失败！";
      }else if (this.$route.query.code == 4) {
          this.response = "认证不通过!登录失败！";
          this.isError = true;
      }else if (this.$route.query.code == 5) {
          this.response = "认证已过期!请重试！";
          this.isError = true;
      }else if (this.$route.query.code == "wechatma") {
        this.response = "未绑定账号，请退出小程序重新进入！";
        this.isError = false;
      } else if (this.$route.query.code == "wechatmp") {
        this.response = "解绑成功，请关闭页面重新进入！";
        this.isError = false;
      } else if (this.$route.query.code == "errorCas") {
        this.response = "学生未缴费注册，无法登录，请及时进入财务系统缴纳费用！";
        this.isError = false;
      }else {
        this.response = "参数错误";
      }
    },
    aksCasLogin() {
      aApi
        .AKSCasLogin({
          token: this.$route.query.askToken
        })
        .then(res => {
          if (res.code == "0") {
            this.response = res.Msg;
          } else {
            sessionStorage.setItem("userInfo", JSON.stringify(res.data));
            sessionStorage.setItem("Token", res.data.token);
            this.$router.replace("/homeIndex");
          }
        })
        .catch(err => {});
    },
    menuCheck(menu) {
      let ywid =  this.$route.query.ywid;
      let list = this.data.filter(item => item.menu == menu);
      if (list.length === 0) {
         if(sessionStorage.getItem('schoolCode')=="10013"){ 
            this.$router.replace("/new/Home_10013");
         }else{
            this.$router.replace("/homeIndex");
         } 
      } else {
        var path = list[0].path;
        if(this.$route.query.toParamId != null && this.$route.query.toParamId != ''){
          var casparamId = this.$route.query.toParamId;
          if(menu == 'js_tksh_detail' || menu == 'js_kctdsh_detail' || menu == 'js_hksh_detail'  || menu == 'js_pyfash_detail' || menu == 'js_cjlrsh_detail'){
            path += "&casparamId="+casparamId;
          }
        }
        if("ysggxq" == menu){
          path+="?id="+ywid;
        }
        this.$router.replace(path)
      }
    },
    ifWechatBrowser() {
      let browser = {
        versions: (function() {
          let u = navigator.userAgent,
            app = navigator.appVersion;
          return {
            //移动终端浏览器版本信息
            trident: u.indexOf("Trident") > -1, //IE内核
            presto: u.indexOf("Presto") > -1, //opera内核
            webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或uc浏览器
            iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("iPad") > -1, //是否iPad
            webApp: u.indexOf("Safari") == -1 //是否web应该程序，没有头部与底部
          };
        })(),
        language: (
          navigator.browserLanguage || navigator.language
        ).toLowerCase()
      };
      if (browser.versions.mobile) {
        let ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          // 阿克苏
          if (this.$route.query.askToken) {
            this.aksCasLogin();
          } else if (this.$route.query.token) {
            // this.wechatLogin()
          } else {
            this.codeDiffer();
          }
        }
      }
    },
    // .net微信平台登录 学工
    async wechatLogin() {
      // alert(localStorage.getItem('qz-wx-token') || '未获取到token')
      let token = { token: this.$route.query.token };
      const res = await aApi.dotNetCasLogin(token);
      if (res.code == "0") {
        this.response = res.Msg;
      } else {
        sessionStorage.setItem("userInfo", JSON.stringify(res.data));
        sessionStorage.setItem("Token", res.data.token);
        
        if(sessionStorage.getItem('schoolCode')=="10013"){ 
            this.$router.replace("/new/Home_10013");
         }else{ 
            this.$router.replace("/homeIndex");
         }
      }
    }
  }
  //阿克苏教育
};
</script>
<style lang="less" scoped>
.cas-ban {
  padding: 8px 20px;
  margin-top: 50px;
}
.cas-ban img {
  height: 111px;
  width: 100%;
}
.cas-code {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.cas-code img {
  width: 64px;
  height: 64px;
}
.cas-code p {
  color: @attendance-color-1;
  font-weight: 300;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/casLogin.vue